/**
 * Error logger for Good Atoms.
 * Dev: readable console output. Production: structured JSON (captured by Cloudflare Logs).
 */

interface ErrorContext {
  userId?: string;
  childId?: string;
  page?: string;
  action?: string;
  [key: string]: unknown;
}

const isDev = import.meta.env.DEV;

export function logError(source: string, error: unknown, context?: ErrorContext) {
  const message = error instanceof Error ? error.message : String(error);
  const stack = error instanceof Error ? error.stack : undefined;

  if (isDev) {
    console.error(`[${source}]`, message, context ?? '', stack ?? '');
    return;
  }

  console.error(JSON.stringify({
    level: 'error',
    source,
    message,
    stack,
    ...context,
    timestamp: new Date().toISOString(),
  }));
}

export function logWarn(source: string, message: string, context?: ErrorContext) {
  if (isDev) {
    console.warn(`[${source}]`, message, context ?? '');
    return;
  }

  console.warn(JSON.stringify({
    level: 'warn',
    source,
    message,
    ...context,
    timestamp: new Date().toISOString(),
  }));
}
